import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CostCenterDto } from 'src/app/models/CostCenterDto';
import { DepartmentDto } from 'src/app/models/DepartmentDto';
import { FunctionDto } from 'src/app/models/FunctionDto';
import { LocationDto } from 'src/app/models/LocationDto';
import { CostCentersService } from 'src/app/services/costcenters.service';
import { DepartmentsService } from 'src/app/services/departments.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { LocationsService } from 'src/app/services/locations.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { UserService } from 'src/app/services/user.service';
import { ManpowerRequestVM } from 'src/app/models/requests/ManpowerRequestVM';
import { NotificationType } from 'src/app/models/notification.message';
import { ManPowersService } from 'src/app/services/man-powers.service';
import { Profile } from 'src/app/models/profile';
import { Observable } from 'rxjs/internal/Observable';
import { ReplaySubject } from 'rxjs';
import { ManPowerDraftsService } from 'src/app/services/man-powerDrafts.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-manpower',
  templateUrl: './new-manpower.component.html',
  styleUrls: ['./new-manpower.component.css']
})
export class NewManpowerComponent implements OnInit {
  
  @ViewChild('ngNewManPowerForm') theForm: any;
  
  // Cache key for localStorage
  private readonly CACHE_KEY = 'manpower_form_cache';
  
  currentUser: any;
  @Input() deleteLink = true;
  @Input() panelTitle = 'Document Uploads';
  @Input() showUploadForm = true;

  @Input() applicationId!: number;
  @Input() referenceNumber = '';

  uploadFileTitle: string = '';
  files!: FileList;
  file!: File;
  fileDocument: any;
  isSelected: boolean = false;
  clicked : boolean = false;
  funcdirectorCount : number = 0;
  hrbpCount : number = 0;
  hrCount : number = 0;
  ceoCount : number = 0;
 
  Locations: LocationDto[] | undefined;
  Functions:FunctionDto[]=[];
  Departments: DepartmentDto[] = [];
  CostCenters: CostCenterDto[] | undefined;
  selectedLocationId: string = ''
  dateVacancyOccured:Date | null = null;
  selectedDepartmentId: string = ''
  selectedPlantManagerId: string = ''
  selectedCostCenterId: string = ''
  selectedFunctionId: string = ''
  description: string = ''
  requesterName: string = ''
  justification: string = '';
  requestorName: string = '';
  ftcdurationofcontract: number = 0;
  ftcestimatedcost: number = 0
  consDurationOfContract: number = 0;
  consEstimatedcost: number = 0;
  internDurationofcontract: number = 0;
  internEstimatedcost: number = 0;
  designation: string = '';
  jobTitle: string = '';
  documentDescription: string = '';
  nPlusOneDsignation: string = '';
  Band: string = '';
  hrbpToApprove: string ='';                 
  ceoToApprove:string ='';
  otherReasonForVacancy: string = '';
  requiredNumber: number | null = null;
  IsPlantManagerToApprove: boolean = false
  typeOfVacancy:  string = '';
  reasonForVacancy: string = '';
  modeOfRecruitment: string = '';
  InternalExternal: string = '';
  DocumentContent: string = '';
  durationofcontract: number = 0;
  estimatedcost: number = 0;
  educationalqualification: string = '';
  skillsrequired: string = '';
  isreasonForVacancyVisible:boolean=false;
  isreasonForVacancy:boolean=false;
  isShowPlantManager:boolean=false;
  experience: string = '';
  systemRequirements: any ={
    BCMIX : false,
    LABMIX : false,
    HOLDIM : false,
    SALESFORCE : false,
    SAP : false
  };
  base64Output: string='';
  FTERequirements: any ={
    InternalMovement : false,
    ExternalNewStaff : false,
  };

  modeofrecruitments: any ={
    FTEInternalMovement : false,
    FTEExternalNewStaff : false,
  };
  ImageBaseData?:string | ArrayBuffer= undefined;
  

  band = [
    { name: "A"},
    {  name: "B"},
    {  name: "C"},
    { name: "D"},
    { name: "E"},
    { name: "F"},
    { name: "F PLUS"},
    { name: "G"},
    { name: "H"},
    { name: "N/A"}
  ];

  typeofvacancy = [
    { vacancy: "FTE"},
    {  vacancy: "CONSULTANT"},
    { vacancy: "INTERNSHIP"},
  ];

  ModeOfrecRuitment = [
    { modeofrecruitments: "FTE"},
    {  modeofrecruitments: "FTC"},
    {  modeofrecruitments: "CONSULTANT"},
    { modeofrecruitments: "INTERNSHIP"},
  ];

  Reasonforvacancy = [
    { reasonforvacancy: "RESIGNATION"},
    {  reasonforvacancy: "TERMINATION"},
    {  reasonforvacancy: "DISMISSAL"},
    { reasonforvacancy: "RETIREMENT"},
    { reasonforvacancy: " NEW POSITION:"},
    { reasonforvacancy: " TRANSFER"},
  ];
  
  otherRequirements: string='';
  selectedManagerId:string="";
  selectedfunctionalDirectorId:string="";
  Managers:Profile[]=[];
  selectedhrbpId:string="";
  HRBPS:Profile[]=[];
  FunctionalDirectors:Profile[]=[];
  PlantManagers:Profile[]=[];
  ohrdToApprove: string = '';
  requestDate: Date | null = null;

  constructor(
    private locationService: LocationsService,
    private notification: NotificationService,
    private ManPowerService: ManPowersService, 
    private ManPowerDraftsService: ManPowerDraftsService, 
    private router: Router,
    private costCenterService: CostCentersService,
    private department: DepartmentsService, 
    private nznotification: NzNotificationService, 
    private tokenService: TokenService,  
    private userService: UserService,
    private functionService:FunctionsService,
  ) { }

  ngOnInit(): void {
    this.LoadDropDowns();
    // Load cached data after dropdowns are loaded
    setTimeout(() => {
      this.loadCachedData();
    }, 500);
  }

  /**
   * Save form data to localStorage
   */
  saveToCache(): void {
    const formData = {
      // Requester Details
      requesterName: this.requesterName,
      designation: this.designation,
      selectedDepartmentId: this.selectedDepartmentId,
      selectedFunctionId: this.selectedFunctionId,
      requestDate: this.requestDate,
      
      // Details Of Required Manpower
      jobTitle: this.jobTitle,
      nPlusOneDsignation: this.nPlusOneDsignation,
      Band: this.Band,
      selectedCostCenterId: this.selectedCostCenterId,
      selectedLocationId: this.selectedLocationId,
      dateVacancyOccured: this.dateVacancyOccured,
      requiredNumber: this.requiredNumber,
      typeOfVacancy: this.typeOfVacancy,
      reasonForVacancy: this.reasonForVacancy,
      otherReasonForVacancy: this.otherReasonForVacancy,
      
      // Mode Of Recruitment
      modeOfRecruitment: this.modeOfRecruitment,
      FTERequirements: this.FTERequirements,
      durationofcontract: this.durationofcontract,
      estimatedcost: this.estimatedcost,
      justification: this.justification,
      
      // Role Requirements
      educationalqualification: this.educationalqualification,
      skillsrequired: this.skillsrequired,
      experience: this.experience,
      systemRequirements: this.systemRequirements,
      otherRequirements: this.otherRequirements,
      
      // Approvals
      selectedManagerId: this.selectedManagerId,
      selectedPlantManagerId: this.selectedPlantManagerId,
      selectedfunctionalDirectorId: this.selectedfunctionalDirectorId,
      selectedhrbpId: this.selectedhrbpId,
      
      // Additional state
      isShowPlantManager: this.isShowPlantManager,
      isreasonForVacancyVisible: this.isreasonForVacancyVisible,
      isreasonForVacancy: this.isreasonForVacancy,
      funcdirectorCount: this.funcdirectorCount,
      hrbpCount: this.hrbpCount,
      hrCount: this.hrCount,
      ceoCount: this.ceoCount,
    };

    try {
      localStorage.setItem(this.CACHE_KEY, JSON.stringify(formData));
    } catch (error) {
      console.error('Error saving to cache:', error);
    }
  }

  /**
   * Load cached data from localStorage
   */
  loadCachedData(): void {
    try {
      const cachedData = localStorage.getItem(this.CACHE_KEY);
      if (cachedData) {
        const formData = JSON.parse(cachedData);
        
        // Requester Details
        this.requesterName = formData.requesterName || '';
        this.designation = formData.designation || '';
        this.selectedDepartmentId = formData.selectedDepartmentId || '';
        this.selectedFunctionId = formData.selectedFunctionId || '';
        this.requestDate = formData.requestDate || null;
        
        // Details Of Required Manpower
        this.jobTitle = formData.jobTitle || '';
        this.nPlusOneDsignation = formData.nPlusOneDsignation || '';
        this.Band = formData.Band || '';
        this.selectedCostCenterId = formData.selectedCostCenterId || '';
        this.selectedLocationId = formData.selectedLocationId || '';
        this.dateVacancyOccured = formData.dateVacancyOccured || null;
        this.requiredNumber = formData.requiredNumber || null;
        this.typeOfVacancy = formData.typeOfVacancy || '';
        this.reasonForVacancy = formData.reasonForVacancy || '';
        this.otherReasonForVacancy = formData.otherReasonForVacancy || '';
        
        // Mode Of Recruitment
        this.modeOfRecruitment = formData.modeOfRecruitment || '';
        if (formData.FTERequirements) {
          this.FTERequirements = formData.FTERequirements;
        }
        this.durationofcontract = formData.durationofcontract || 0;
        this.estimatedcost = formData.estimatedcost || 0;
        this.justification = formData.justification || '';
        
        // Role Requirements
        this.educationalqualification = formData.educationalqualification || '';
        this.skillsrequired = formData.skillsrequired || '';
        this.experience = formData.experience || '';
        // if (formData.systemRequirements) {
        //   this.systemRequirements = formData.systemRequirements;
        // }
        this.otherRequirements = formData.otherRequirements || '';
        
        // Approvals
        this.selectedManagerId = formData.selectedManagerId || '';
        this.selectedPlantManagerId = formData.selectedPlantManagerId || '';
        this.selectedfunctionalDirectorId = formData.selectedfunctionalDirectorId || '';
        this.selectedhrbpId = formData.selectedhrbpId || '';
        
        // Additional state
        this.isShowPlantManager = formData.isShowPlantManager || false;
        this.isreasonForVacancyVisible = formData.isreasonForVacancyVisible || false;
        this.isreasonForVacancy = formData.isreasonForVacancy || false;
        this.funcdirectorCount = formData.funcdirectorCount || 2;
        this.hrbpCount = formData.hrbpCount || 3;
        this.hrCount = formData.hrCount || 4;
        this.ceoCount = formData.ceoCount || 5;
        
        console.log('Manpower form data loaded from cache');
      }
    } catch (error) {
      console.error('Error loading cached data:', error);
    }
  }

  /**
   * Clear cached data from localStorage
   */
  clearCache(): void {
    try {
      localStorage.removeItem(this.CACHE_KEY);
      console.log('Manpower cache cleared');
    } catch (error) {
      console.error('Error clearing cache:', error);
    }
  }

  onFileChange(event : any) {
    this.files = event.target.files;
    this.file = this.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(this.file);
    reader.onload = () => {
      console.log(reader.result);
      this.DocumentContent = reader.result as string
    };
    console.log(this.base64Output);
  }

  uploadFile() {
    debugger;
    if (this.file != undefined || this.uploadFileTitle != null) {
      const body = {
        loanApplicationId: this.applicationId,
        loanApplicationNumber: this.referenceNumber,
        loanReferenceNumber: this.referenceNumber,
        documentTitle: this.uploadFileTitle == null ? '' : this.uploadFileTitle,
        fileName: this.file.name,
        physicalFileNumber: 'n/a',
        physicalLocation: 'n/a',
        documentTypeId: '1',
        overwrite: false,
      };
    }
  }

  MyDrafts(){
    this.router.navigate(['/manpowerdrafts']);
  }

  async LoadDropDowns() {
    debugger;
    if (this.isShowPlantManager == false){
      this.funcdirectorCount = 2
      this.hrbpCount = 3
      this.hrCount = 4
      this.ceoCount = 5
    }
    
    this.currentUser = this.tokenService.getInfo();
    let resLocations = await this.locationService.getLocations().toPromise();
    this.Locations = <LocationDto[]>resLocations.responseData;
    
    let resCostCenterss = await this.costCenterService.getCostCenters().toPromise();
    this.CostCenters = <CostCenterDto[]>resCostCenterss.responseData;
    
    let resDeparts = await this.department.getDepartments().toPromise();
    this.Departments = <DepartmentDto[]>resDeparts.responseData;
    
    let functions = await this.functionService.getAllFunctions().toPromise();
    this.Functions = <FunctionDto[]>functions.responseData;
    
    let usersPro = await this.userService.getManagersUsers().toPromise();
    this.Managers = <Profile[]>usersPro.responseData;

    let userhrpbps = await this.userService.getHRBPS().toPromise();
    this.HRBPS = <Profile[]>userhrpbps.responseData;

    let ohrDirector = await this.userService.getOHRDirector().toPromise();
    let ohrDirectorRes = <Profile[]>ohrDirector.responseData;
    this.ohrdToApprove = ohrDirectorRes[0].email;

    let ceo = await this.userService.getCEO().toPromise();
    let ceoRes = <Profile[]>ceo.responseData;
    this.ceoToApprove = ceoRes[0].email;

    let directors = await this.userService.getFunctionalDirectors().toPromise();
    this.FunctionalDirectors = <Profile[]>directors.responseData;
    
    let plantManager = await this.userService.getManagersUsers().toPromise();
    this.PlantManagers = <Profile[]>plantManager.responseData;
  }

  onSubmit(): void {
    this.clicked = true;
    let req : string[] = [];
    let selectedReqVal = Object.values(this.systemRequirements),
    selectedReqKeys = Object.keys(this.systemRequirements);

    selectedReqVal.forEach((x:any,i:number) =>{
      if(x) req.push(selectedReqKeys[i])
    })
    let systemRequired = req.join(',');
    
    if(this.modeOfRecruitment == "FTE")
      debugger
      let reqFte : string[] = [];
      let selectedReqValFte = Object.values(this.FTERequirements),
      selectedReqKeysFte = Object.keys(this.FTERequirements);

      selectedReqValFte.forEach((x:any,i:number) =>{
        if(x) reqFte.push(selectedReqKeysFte[i])
      })
      let fteRequired = reqFte.join(',');
      fteRequired == this.modeOfRecruitment

    if(this.selectedPlantManagerId != ''){
      this.IsPlantManagerToApprove = true
    }
  
    if(this.otherReasonForVacancy != '') this.reasonForVacancy = this.otherReasonForVacancy
    
    let ManpowerRequestVM: ManpowerRequestVM = {
      requesterDesignation: this.designation,
      requesterName: this.requesterName,
      requesterFunction: this.selectedDepartmentId,
      requesterUnit: this.selectedFunctionId,
      requestDate: this.requestDate,
      jobTitle: this.jobTitle,
      JobDescription: {
        RequestId: 0,
        DocumentName: this.file.name,
        DocumentContent: this.DocumentContent,
        ContentType: (this.ManPowerService.fileExtention(this.file.name)).toLowerCase(),
        DocumentDescription: this.documentDescription,
      },
      nPlus1Designation: this.nPlusOneDsignation,
      band: this.Band,
      costCenter: this.selectedCostCenterId,
      location: this.selectedLocationId,
      dateVacancyOccurred: this.dateVacancyOccured,
      requiredNumber: this.requiredNumber,
      typeOfVacancy: this.typeOfVacancy,
      reasonForVacancy: this.reasonForVacancy,
      modeOfRecruitment: fteRequired != ""  ? fteRequired : this.modeOfRecruitment,
      durationOfContract: this.durationofcontract,
      estimatedAnnualCost: this.estimatedcost,
      justificationForVacancy: this.justification,
      qualification: this.educationalqualification,
      skillsRequired: this.skillsrequired,
      experience: this.experience,
      systemRequired:systemRequired,
      otherSystemRequirements:this.otherRequirements ,
      functionDirectorToApprove: this.selectedfunctionalDirectorId,
      IsPlantManagerToApprove:this.IsPlantManagerToApprove,
      PlantManagerToApprove:this.selectedPlantManagerId,
      hrbpToApprove: this.selectedhrbpId,
      unitHeadToApprove: this.selectedManagerId,
      ohrdToApprove: this.ohrdToApprove,
      CeoToApprove: this.ceoToApprove
    };
    
    debugger;
    this.ManPowerService.saveManPower(ManpowerRequestVM).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: `Request created successfully`,
            type: NotificationType.success
          });
        
          // Clear cache on successful submission
          this.clearCache();
          
          this.theForm.resetForm();    
          this.clicked = false;
        } else {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });
          this.clicked = false;
        }
      }),
      error: ((error: any) => {
        console.log(error.error);
        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
        this.clicked = false;
      })
    });
  }

  SaveDraft(): void {
    debugger;
    this.clicked = true;
    let req : string[] = [];
    let selectedReqVal = Object.values(this.systemRequirements),
    selectedReqKeys = Object.keys(this.systemRequirements);

    selectedReqVal.forEach((x:any,i:number) =>{
      if(x) req.push(selectedReqKeys[i])
    })
    let systemRequired = req.join(',');
    
    if(this.modeOfRecruitment == "FTE")
      debugger
      let reqFte : string[] = [];
      let selectedReqValFte = Object.values(this.FTERequirements),
      selectedReqKeysFte = Object.keys(this.FTERequirements);

      selectedReqValFte.forEach((x:any,i:number) =>{
        if(x) reqFte.push(selectedReqKeysFte[i])
      })
      let fteRequired = reqFte.join(',');
      fteRequired == this.modeOfRecruitment

    if(this.selectedPlantManagerId != ''){
      this.IsPlantManagerToApprove = true
    }
  
    if(this.otherReasonForVacancy != '') this.reasonForVacancy = this.otherReasonForVacancy
    
    let ManpowerRequestVM: ManpowerRequestVM = {
      requesterDesignation: this.designation,
      requesterName: this.requesterName,
      requesterFunction: this.selectedDepartmentId,
      requesterUnit: this.selectedFunctionId,
      requestDate: this.requestDate,
      jobTitle: this.jobTitle,
      JobDescription: this.file ? {
        RequestId: 0,
        DocumentName: this.file.name,
        DocumentContent: this.DocumentContent,
        ContentType: (this.ManPowerDraftsService.fileExtention(this.file.name)).toLowerCase(),
        DocumentDescription: this.documentDescription,
      } : undefined,
      nPlus1Designation: this.nPlusOneDsignation,
      band: this.Band,
      costCenter: this.selectedCostCenterId,
      location: this.selectedLocationId,
      dateVacancyOccurred: this.dateVacancyOccured,
      requiredNumber: this.requiredNumber,
      typeOfVacancy: this.typeOfVacancy,
      reasonForVacancy: this.reasonForVacancy,
      modeOfRecruitment: fteRequired != ""  ? fteRequired : this.modeOfRecruitment,
      durationOfContract: this.durationofcontract,
      estimatedAnnualCost: this.estimatedcost,
      justificationForVacancy: this.justification,
      qualification: this.educationalqualification,
      skillsRequired: this.skillsrequired,
      experience: this.experience,
      systemRequired:systemRequired,
      otherSystemRequirements:this.otherRequirements ,
      functionDirectorToApprove: this.selectedfunctionalDirectorId,
      IsPlantManagerToApprove:this.IsPlantManagerToApprove,
      PlantManagerToApprove:this.selectedPlantManagerId,
      hrbpToApprove: this.selectedhrbpId,
      unitHeadToApprove: this.selectedManagerId,
      ohrdToApprove: this.ohrdToApprove,
      CeoToApprove: this.ceoToApprove
    };
    
    debugger;
    this.ManPowerDraftsService.saveManPower(ManpowerRequestVM).subscribe({
      next: (data => {
        debugger
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: `Draft saved successfully`,
            type: NotificationType.success
          });
          this.clicked = false;
        } else {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });
          this.clicked = false;
        }
      }),
      error: ((error: any) => {
        console.log(error.error);
        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
        this.clicked = false;
      })
    });
  }
      
  onChangeDesignation(event:string) {
    debugger;
    const recruitment:string=(event);
    if(event ==""){ 
      this.isreasonForVacancyVisible=false;
      this.isreasonForVacancy=false;
    }
    let item = this.ModeOfrecRuitment.find(i => i.modeofrecruitments === recruitment);

    if(item?.modeofrecruitments=== "FTE") {
      this.isreasonForVacancyVisible=true;
      this.isreasonForVacancy=false;
    }

    if(item?.modeofrecruitments=== "FTC") {
      this.isreasonForVacancy = true;
      this.isreasonForVacancyVisible=false;
    }

    if(item?.modeofrecruitments=== "CONSULTANT") {
      this.isreasonForVacancy = true;
      this.isreasonForVacancyVisible=false;
    }

    if(item?.modeofrecruitments=== "INTERNSHIP") {
      this.isreasonForVacancy = true;
      this.isreasonForVacancyVisible=false;
    }
    
    // Save to cache after change
    this.saveToCache();
  }

  onChangeFunction(event:string) {
    debugger;
    const manPowerfunction:string=(event);
    let item = this.Departments.find(i => i.name === manPowerfunction);

    if(item?.name=== "INDUSTRIAL") {
      this.isShowPlantManager=true;
      this.funcdirectorCount = 3
      this.hrbpCount = 4
      this.hrCount = 5
      this.ceoCount = 6
    } else {
      this.isShowPlantManager=false;
      this.funcdirectorCount = 2
      this.hrbpCount = 3
      this.hrCount = 4
      this.ceoCount = 5
    }
    
    // Save to cache after change
    this.saveToCache();
  }
  
  async onChangeDepartment(event:string) {
    // Functionality can be added here if needed
  }
}